import { render, staticRenderFns } from "./PromoCodeForm.vue?vue&type=template&id=c5df56ba&scoped=true"
import script from "./PromoCodeForm.vue?vue&type=script&lang=js"
export * from "./PromoCodeForm.vue?vue&type=script&lang=js"
import style0 from "./PromoCodeForm.vue?vue&type=style&index=0&id=c5df56ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5df56ba",
  null
  
)

export default component.exports